export default Object.freeze({
    Read: 1,
    Edit: 2,
    Create: 3,
    Delete: 4,
    Submit: 5,
    Approve: 7,
    CanCopyAsOwn: 8,
})
